import Link from 'next/link'
// Speedbump widget for the PLPs
const Speedbump: React.FC<{ image: string; link: string }> = ({ image, link }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Link href={link}>
        <img style={{ width: '100%', borderRadius: '25px' }} alt="speedbump" src={image} loading="lazy" />
      </Link>
    </div>
  )
}

export default Speedbump
